import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

const SID_KEY = "eggman_visitor_sid";

function getSessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

/** Pings backend with each route change. Coalesces duplicates within 1s. */
export default function usePageTracker() {
  const loc = useLocation();
  const lastRef = useRef("");

  useEffect(() => {
    const path = loc.pathname + (loc.search || "");
    if (lastRef.current === path) return;
    lastRef.current = path;
    // fire-and-forget
    api.post("/track/page", {
      path,
      referrer: document.referrer || "",
      session_id: getSessionId(),
    }).catch(() => {});
  }, [loc.pathname, loc.search]);
}
